import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const SaoTomeAndPrincipeFlagIcon: FC<PropsWithChildren<Props>> = ({
	className,
}) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15904'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15904)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V9.33337H0V14Z'
					fill='#2ACB41'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 4.66667H20V0H0V4.66667Z'
					fill='#2ACB41'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 9.33329H20V4.66663H0V9.33329Z'
					fill='#FDD043'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 0L7.61905 7L0 14V0Z'
					fill='#E71E43'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.477 7.7653L9.35744 8.51013L9.7343 7.23647L8.66549 6.42314L10.018 6.3808L10.477 5.1333L10.9361 6.3808L12.2886 6.42314L11.2198 7.23647L11.5966 8.51013L10.477 7.7653Z'
					fill='#262626'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M15.2387 7.7653L14.1192 8.51013L14.496 7.23647L13.4272 6.42314L14.7797 6.3808L15.2387 5.1333L15.6978 6.3808L17.0503 6.42314L15.9815 7.23647L16.3583 8.51013L15.2387 7.7653Z'
					fill='#262626'
				/>
			</g>
		</svg>
	);
};

export default SaoTomeAndPrincipeFlagIcon;
